/* Kanful ショッピング注意事項 — 配送日付の動的表示
 *
 * 通年:
 *   - 区切り時刻 14 時。14 時までなら当日発送、過ぎたら翌日発送
 *   - 土日はスキップしない (実際に土日も発送しているため)
 *
 * 年末年始 (#120):
 *   発送を止める期間を設定できる。その期間中に見た人には、
 *   休み明けの発送日を出す (例: 12/31 9 時 〜 1/3 は 1/4 発送)。
 *   到着日は発送日 + 1 日で出す (通年と同じ考え方)。
 *   期間・時刻・休み明けの日付は、テーマエディタで入力した値を
 *   セクション側が data 属性で渡す。
 *
 * 年末年始の文言も、テーマエディタで入れた期間だけ出す。
 * 期間を過ぎれば自動で消えるので、消し忘れが起きない。
 */
(function () {
  'use strict';

  var WEEK_KANJI = ['日', '月', '火', '水', '木', '金', '土'];

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  /* 'MM-DD' を数値 (月 * 100 + 日) にする。読めなければ null */
  function parseMonthDay(value) {
    if (!value) return null;
    var m = String(value).trim().match(/^(\d{1,2})\D+(\d{1,2})$/);
    if (!m) return null;
    var month = parseInt(m[1], 10);
    var day = parseInt(m[2], 10);
    if (month < 1 || month > 12 || day < 1) return null;
    // 月ごとの日数を超える指定は無効にする (4-31 を 5/1 と読まないため)。
    // 2 月は 29 まで許す (うるう年に指定できるようにする)
    var maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
    if (day > maxDay) return null;
    return month * 100 + day;
  }

  /* 年をまたぐ期間 (12/1 〜 1/10 など) に入っているか。
     開始 > 終了 のときは年をまたぐものとして扱う */
  function inMonthDayRange(target, from, to) {
    if (target === null || from === null || to === null) return false;
    if (from <= to) return target >= from && target <= to;
    return target >= from || target <= to;
  }

  function monthDayOf(date) {
    return (date.getMonth() + 1) * 100 + date.getDate();
  }

  /* 発送を止めている期間か。
     開始日は startHour 以降だけが対象 (12/31 9 時 〜 のように途中から始まる) */
  function inPauseWindow(now, from, to, startHour) {
    if (from === null || to === null) return false;
    var today = monthDayOf(now);
    if (!inMonthDayRange(today, from, to)) return false;
    if (today === from) return now.getHours() >= startHour;
    return true;
  }

  /* 通年の発送日 / 到着日 */
  function computeNormal(now, addDay, boundaryTime) {
    var extra = now.getHours() >= boundaryTime ? 1 : 0;
    return addDays(now, addDay + extra);
  }

  /* 'MM-DD' を、now を基準にした Date にする。
     年末年始をまたぐので、過ぎている月日は翌年として扱う */
  function monthDayToDate(now, monthDay) {
    if (monthDay === null) return null;
    var month = Math.floor(monthDay / 100);
    var day = monthDay % 100;
    var year = now.getFullYear();
    var d = new Date(year, month - 1, day, 0, 0, 0, 0);
    // 休み明けが年明けの場合 (12/31 に見て 1/4 を出す)
    if (d.getTime() < new Date(year, now.getMonth(), now.getDate()).getTime()) {
      d = new Date(year + 1, month - 1, day, 0, 0, 0, 0);
    }
    return d;
  }

  function formatJp(date) {
    return (date.getMonth() + 1) + '月' + date.getDate() + '日(' + WEEK_KANJI[date.getDay()] + ')';
  }

  /* 発送を止めている日か (その日付が休業期間に入っているか)。
     「今」ではなく「その日付」を見る。
     これを見ないと、12/30 15 時に見たときの発送日 (12/31) が
     休業中の日なのにそのまま出てしまう。

     休業の初日は締切時刻まで発送できるので、丸ごと休みではない。
     「今」がその初日なら、締切前は休業日と見なさない
     (12/31 8 時に見たら 12/31 発送のままにする)。 */
  function isPausedDay(date, from, to, now, startHour) {
    if (from === null || to === null) return false;
    var target = monthDayOf(date);
    if (!inMonthDayRange(target, from, to)) return false;
    // 休業の初日ちょうど、かつ今もその日で、まだ締切前なら発送できる
    if (target === from && now && monthDayOf(now) === from
        && now.getHours() < startHour) {
      return false;
    }
    return true;
  }

  /* 発送日を決める。
     ・今が休業中 → 休み明け
     ・ふだんの計算で出た日が休業中 → 休み明け
     ・それ以外 → ふだんどおり */
  function pickShippingDate(now, conf) {
    var resume = monthDayToDate(now, conf.resumeOn);
    if (!resume) return computeNormal(now, 0, conf.boundaryTime);

    if (inPauseWindow(now, conf.pauseFrom, conf.pauseTo, conf.pauseStartHour)) {
      return resume;
    }
    var normal = computeNormal(now, 0, conf.boundaryTime);
    if (isPausedDay(normal, conf.pauseFrom, conf.pauseTo, now, conf.pauseStartHour)) {
      return resume;
    }
    return normal;
  }

  /* 出す日付を決める。
     addDay: 発送日は 0、到着日は 1 (発送日の翌日)

     到着日は発送日 + addDay をそのまま出す。休業中でもずらさない。
     休むのは発送の業務で、発送さえ済めばあとは配送業者が運ぶため
     (12/30 発送なら 12/31 に届く)。 */
  function pickDate(now, addDay, conf) {
    var shipping = pickShippingDate(now, conf);
    if (addDay <= 0) return shipping;
    return addDays(shipping, addDay);
  }

  /* 設定が読めなかったときの既定値。
     締切は 14 時。文章側の「○時までのご注文は」は applyBoundaryHour が同じ値で埋める (#255) ので、
     この値がずれても文章と日付は食い違わない（JS 無効時は product.json に書かれた 14 が出る）。 */
  var DEFAULTS = {
    boundaryTime: 14,
    pauseStartHour: 9
  };

  function readConfig(root) {
    var d = (root && root.dataset) || {};
    var hour = parseInt(d.boundaryTime, 10);
    var pauseHour = parseInt(d.pauseStartHour, 10);
    return {
      boundaryTime: isNaN(hour) ? DEFAULTS.boundaryTime : hour,
      pauseFrom: parseMonthDay(d.pauseFrom),
      pauseTo: parseMonthDay(d.pauseTo),
      pauseStartHour: isNaN(pauseHour) ? DEFAULTS.pauseStartHour : pauseHour,
      resumeOn: parseMonthDay(d.resumeOn),
      noticeFrom: parseMonthDay(d.noticeFrom),
      noticeTo: parseMonthDay(d.noticeTo)
    };
  }

  function applyDate(className, addDay, now, conf) {
    var nodes = document.querySelectorAll('.' + className);
    if (!nodes.length) return;
    var text = formatJp(pickDate(now, addDay, conf));
    Array.prototype.forEach.call(nodes, function (el) {
      el.textContent = text;
    });
  }

  /* 文中の締切時刻（「14時までのご注文は」の 14）を設定値で埋める (#255)。
     product.json のリッチテキストに <span class="kf-boundary-hour">14</span> を置き、JS 無効時は 14 のまま出る */
  function applyBoundaryHour(conf) {
    var nodes = document.querySelectorAll('.kf-boundary-hour');
    if (!nodes.length) return;
    Array.prototype.forEach.call(nodes, function (el) {
      el.textContent = String(conf.boundaryTime);
    });
  }

  /* 月日だけの表記（曜日なし）。年末年始の文言用 */
  function formatMonthDay(monthDay) {
    return Math.floor(monthDay / 100) + '月' + (monthDay % 100) + '日';
  }

  /* 年末年始の文言の日付・時刻を休業設定で埋める (#257)。
     product.json の period_notice に置いた span:
       .kf-pause-full-from  丸一日休みの初日（pause_start_hour が 0 なら pause_from、それ以外は翌日）
       .kf-pause-to         休業の最終日
       .kf-pause-from       途中から止める日（pause_from）
       .kf-pause-start-hour その時刻
       .kf-resume-on        再開日
     月日 3 項目（pauseFrom / pauseTo / resumeOn）のどれかが無ければ触らない（pauseStartHour は readConfig が必ず数値にする）。
     その場合、この span を含む文言は applyNotice が期間内でも隠す（古い日付の休業文を出さない） */
  function pauseTextComplete(conf) {
    return conf.pauseFrom !== null && conf.pauseTo !== null && conf.resumeOn !== null;
  }

  function applyPauseText(now, conf) {
    if (!pauseTextComplete(conf)) return;
    var fullFrom = conf.pauseFrom;
    if (conf.pauseStartHour > 0) {
      var d = monthDayToDate(now, conf.pauseFrom);
      d.setDate(d.getDate() + 1);
      fullFrom = monthDayOf(d);
      // 半日だけの休業（開始日 = 最終日、途中から止める）では翌日が最終日を超える。
      // 「1月1日〜12月31日」のような逆転を出さず、最終日に揃える
      if (monthDayToDate(now, fullFrom).getTime() > monthDayToDate(now, conf.pauseTo).getTime()) {
        fullFrom = conf.pauseTo;
      }
    }
    var values = {
      'kf-pause-full-from': formatMonthDay(fullFrom),
      'kf-pause-to': formatMonthDay(conf.pauseTo),
      'kf-pause-from': formatMonthDay(conf.pauseFrom),
      'kf-pause-start-hour': String(conf.pauseStartHour),
      'kf-resume-on': formatMonthDay(conf.resumeOn)
    };
    Object.keys(values).forEach(function (cls) {
      Array.prototype.forEach.call(document.querySelectorAll('.' + cls), function (el) {
        el.textContent = values[cls];
      });
    });
  }

  /* 期間限定の文言を出す / 隠す。
     期間が入力されていなければ隠したままにする */
  function applyNotice(now, conf) {
    var nodes = document.querySelectorAll('[data-kf-period-notice]');
    if (!nodes.length) return;
    var inRange = inMonthDayRange(monthDayOf(now), conf.noticeFrom, conf.noticeTo);
    var pauseOk = pauseTextComplete(conf);
    Array.prototype.forEach.call(nodes, function (el) {
      // 休業日の span を含む文言は、休業設定が揃っていないと product.json の古い日付のまま出るので隠す (#257)
      var hasPauseSpans = el.querySelector && el.querySelector('.kf-pause-from, .kf-pause-to, .kf-pause-full-from, .kf-resume-on');
      var show = inRange && (!hasPauseSpans || pauseOk);
      if (show) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function init() {
    var root = document.querySelector('[data-kf-shipping-conf]');
    var conf = readConfig(root);
    var now = new Date();
    // 発送日は当日 (0)、到着日はその翌日 (1)。
    // 文章が「○時までのご注文は ○月○日 に発送いたします」なので、
    // 出すのは「いつ発送されるか」そのもの
    applyBoundaryHour(conf);
    applyDate('kf-hassou-date', 0, now, conf);
    applyDate('kf-toucyaku-date', 1, now, conf);
    // 発送日を埋めた後に（ここで例外が出ても上の表示は残る）
    applyPauseText(now, conf);
    applyNotice(now, conf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テストから確かめられるように出す (#120)
  if (typeof window !== 'undefined') {
    window.KanfulShippingDate = {
      parseMonthDay: parseMonthDay,
      inMonthDayRange: inMonthDayRange,
      DEFAULTS: DEFAULTS,
      readConfig: readConfig,
      applyBoundaryHour: applyBoundaryHour,
      applyPauseText: applyPauseText,
      pauseTextComplete: pauseTextComplete,
      applyNotice: applyNotice,
      formatMonthDay: formatMonthDay,
      inPauseWindow: inPauseWindow,
      isPausedDay: isPausedDay,
      pickShippingDate: pickShippingDate,
      computeNormal: computeNormal,
      monthDayToDate: monthDayToDate,
      pickDate: pickDate,
      formatJp: formatJp
    };
  }
}());
